/**
 * Applies the event listener to the given element(s).
 * WordPress and jQuery compatible version with NO ES6 exports.
 *
 * @example
 * ```js
 * // Creates an event listener on window scroll
 * const off = on(window, 'scroll', onScroll);
 * // Returns function to remove event listener when you're done
 * off();
 * ```
 *
 * @example
 * ```js
 * // Handles one or multiple elements
 * const off = on([input, input2, input3], 'blur', onBlur);
 * ```
 *
 * @example
 * ```js
 * // Works with jQuery objects too
 * const off = on($('#my-element')[0], 'click', handler);
 * ```
 *
 * @param {HTMLElement|HTMLElement[]|jQuery} elementOrMultiple one or many HTML elements to apply the listener to
 * @param {string} type the type of event to apply
 * @param {Function} listener the event listener callback
 * @param {boolean|EventListenerOptions} options the event listener options to use
 * @returns {Function} a function that unsubscribes from any event listeners
 */
(function (global) {
  "use strict";

  const on = (elementOrMultiple, type, listener, options) => {
    let elements = elementOrMultiple;

    // Handle jQuery objects
    if (elementOrMultiple && typeof elementOrMultiple.jquery !== "undefined") {
      elements = Array.from(elementOrMultiple);
    }
    // Handle single elements
    else if (!Array.isArray(elementOrMultiple)) {
      elements = [elementOrMultiple];
    }

    // Filter out null/undefined elements
    elements = elements.filter((el) => el && el.addEventListener);

    elements.forEach((el) => {
      if (el && el.addEventListener) {
        el.addEventListener(type, listener, options);
      }
    });

    return () => {
      elements.forEach((el) => {
        if (el && el.removeEventListener) {
          el.removeEventListener(type, listener, options);
        }
      });
    };
  };

  // Make available globally (WordPress compatible)
  global.on = on;

  // Also make available as CommonJS module if needed
  if (typeof module !== "undefined" && module.exports) {
    module.exports = on;
  }
})(typeof window !== "undefined" ? window : this);
